import {
  Box,
  Flex,
  Text,
  useColorMode,
  BoxProps,
  Image,
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import { NavContext } from "../layout";
import { ChatsContext } from "../../context/ChatContext";
import UnreadBadge from "../Chats/UnreadBadge";

export type NavItemProps = {
  icon: string;
  active?: boolean;
  count?: number;
  href?: string;
  name: string;
  onClick?: () => void;
};

const NavItem = (props: NavItemProps) => {
  const { colorMode } = useColorMode();
  const sidebarState = useContext(NavContext);
  const { tabNotificationCount, setTabNotificationCount } =
    useContext(ChatsContext);
  const location = useLocation();
  const isOnChatPage = location.pathname === "/chats";

  const activeProps: BoxProps = {
    border: "1px #017172 solid",
    bg: colorMode === "light" ? "#F5F7F9" : "transparent",
  };

  return (
    <Link to={`${props.href}`}>
      <Box
        data-cy={props.href}
        bg={colorMode === "light" ? "#F5F7F9" : "transparent"}
        h={"48px"}
        // w={{ base: "100%", md: "262px" }}
        borderRadius={"8px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        mb={2}
        px={2}
        cursor={"pointer"}
        {...(props.active && activeProps)}
        onClick={() => {
          sidebarState.onClose();
          if (props.href === "/chats" && tabNotificationCount > 0) {
            setTabNotificationCount(0);
          }
        }}
      >
        <Flex alignItems={"center"}>
          <Image src={props.icon} />
          <Text
            fontSize="16px"
            fontWeight={500}
            w={"100%"}
            ml={5}
            color={
              props.active
                ? "primary.900"
                : colorMode === "light"
                ? "dark.500"
                : "#fff"
            }
          >
            {props.name}
          </Text>
        </Flex>
        {props.href === "/chats" &&
        tabNotificationCount > 0 &&
        !isOnChatPage ? (
          <UnreadBadge count={tabNotificationCount} />
        ) : props.active ? (
          <Image src="/images/chevron-right-active.svg" />
        ) : colorMode === "light" ? (
          <Image src="/images/chevron-right.svg" />
        ) : (
          <Image src="/images/chevron-right-white.svg" />
        )}
      </Box>
    </Link>
  );
};

export default NavItem;
